import React, { useState } from 'react';
import { Flex } from 'antd';

import DateRangePickerWithContext from '@totem/components/common/dateRangePicker/DateRangePickerWithContext';
import BilledTable from '@totem/components/ticketing/billing/billedTable';
import BilledUnbilledSummary from '@totem/components/ticketing/billing/billedUnbilledSummary';
import ButtonCreateBilling from '@totem/components/ticketing/billing/buttonCreateBilling';
import UnbilledSelectedCounts from '@totem/components/ticketing/billing/unbilledSelectedCounts';
import UnbilledTable from '@totem/components/ticketing/billing/unbilledTable';
import IBTabs from '@totem/components/ui_components/antDesignOverrides/IBTabs';

const UnbilledPane = () => {
  const [selectedTab, setSelectedTab] = useState<string>('unbilled');

  const getTabExtraContent = () => {
    switch (selectedTab) {
      case 'unbilled':
        return (
          <div style={{ width: '100%' }}>
            <Flex justify={'space-between'} align={'center'}>
              <div style={{ marginRight: '32px' }}>
                <DateRangePickerWithContext />
              </div>
              <Flex justify={'flex-end'} align={'center'} gap={24}>
                <BilledUnbilledSummary />
                <span style={{ color: '#ff0000' }}>
                  <UnbilledSelectedCounts />
                </span>
                <ButtonCreateBilling />
              </Flex>
            </Flex>
          </div>
        );
      default:
        return (
          <div style={{ width: '100%' }}>
            <Flex justify={'space-between'} align={'center'}>
              <div style={{ marginRight: '32px' }}>
                <DateRangePickerWithContext />
              </div>
              <BilledUnbilledSummary />
            </Flex>
          </div>
        );
    }
  };

  return (
    <IBTabs
      defaultActiveKey="unbilled"
      activeKey={selectedTab}
      items={[
        {
          key: 'unbilled',
          label: 'Unbilled',
          children: <UnbilledTable />,
        },
        {
          key: 'billed',
          label: 'Billed',
          children: <BilledTable />,
        },
      ]}
      onChange={setSelectedTab}
      tabBarExtraContent={getTabExtraContent()}
    />
  );
};

export default UnbilledPane;
